import React from 'react';
import { Animated } from 'react-animated-css';
import moment from 'moment';
import conversionRates from '../../../conversionRates';

class WidgetConversionRate extends React.Component {
    state = {
        Flag: 'day'
    }
    componentWillMount = () => {
        this.props.logic_actions?.fetch_conversion_rates();        
    }    

    render() {
        const { Flag } = this.state, { bookings } = this.props;
        let rates = conversionRates.R();
        return <Animated animationIn='fadeInRight' animationInDelay={800} className="w-50 bg-gray-2 px-3 py-2 rounded">
            <div className="d-flex">
                <span className="poppins font-12 white align-self-start">Tasas</span>
                <div className="ms-auto d-flex flex-column">
                {rates && <span className="poppins font-12 blue ms-auto align-self-center">{`USD ${rates.usd?.toFixed(2)}`}</span>}
                {rates && <span className="poppins font-12 blue ms-auto align-self-center">{`EUR ${rates.eur?.toFixed(2)}`}</span>}
                </div>
                {/*{!bookings && <span className="poppins font-16 gray ms-auto align-self-center"><i className="fas fa-cog fa-spin" /></span>}
                {bookings && <span className="ms-auto align-self-center"><span className="poppins font-16 blue align-self-center">{`${_.filter(bookings, b => b.Source === 'WEB' && !b.IsQuote).length} | ${_.filter(bookings, b => b.Source !== 'WEB' && !b.IsQuote).length}`}</span></span>}*/}
            </div>
            {/*<div className="d-flex mt-2">

                <i className="icon-download font-16 transparent ms-auto align-self-center" />
            </div>*/}
        </Animated>
    }
}

export default WidgetConversionRate;